import "@fontsource-variable/manrope/wght.css";
import "@fontsource-variable/jetbrains-mono/wght.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app";
import { posthogConfig } from "./providers/posthog";

const queryClient = new QueryClient();

// https://posthog.com/docs/libraries/react
//
if (posthogConfig.apiKey) {
	posthog.init(posthogConfig.apiKey, posthogConfig.options);
}

function determineBasename(): string {
	const rootPath = import.meta.env.VITE_ROOTPATH as string;

	if (rootPath.length === 0 || rootPath === "/") {
		return "/";
	}

	if (rootPath.endsWith("/")) {
		return rootPath.slice(0, -1);
	}

	return rootPath;
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<ThemeProvider attribute="class" defaultTheme="system" enableSystem>
			<PostHogProvider client={posthog}>
				<BrowserRouter basename={determineBasename()}>
					<QueryClientProvider client={queryClient}>
						<App />
					</QueryClientProvider>
				</BrowserRouter>
			</PostHogProvider>
		</ThemeProvider>
	</React.StrictMode>,
);
